module.exports = __webpack_public_path__ + "MagicandStitchcraft.jpg?fd3538bb276edbe1456edf767d4813fc";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/MagicandStitchcraft.jpg
// module id = 523
// module chunks = 0